module.exports = __webpack_public_path__ + "static/media/us.4f3999a6.svg";